import React, { useEffect, useState } from "react";
import {
	Checkbox,
	FormGroup,
	FormControlLabel,
	TextField,
} from "@mui/material";
import styles from "./input.module.css";

const target_optionId = process.env.REACT_APP_SCB_OP;
const target_quizId = process.env.REACT_APP_SCB_QID;
const target_quizid_skipped = process.env.REACT_APP_SCB_QIDS;

const SolinaCheckboxes = (props) => {
	const {
		quizOptions,
		question,
		field,
		setValue,
		hasError,
		errorMessage,
		hasOthersError,
		onLogicChange,
		index,
	} = props;

	const [selectedValues, setSelectedValues] = useState(field?.value ?? []);
	const [otherText, setOtherText] = useState("");
	const [error, setError] = useState({
		show: false,
		message: "",
	});
	const properOptions = quizOptions
		.filter((option) => option?.option_text?.trim() !== "")
		.map((option) => {
			const optionId = option?.option_id
				? option.option_id
				: quizOptions[1].option_id - 1;

			return {
				...option,
				option_id: optionId,
			};
		});

	const othersOptionIndex = quizOptions.findIndex((item) =>
		item.option_text.toLowerCase().includes("other")
	);

	const isOtherSelected = selectedValues.find((item) =>
		item.option_text.toLowerCase().includes("other")
	);

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const handleChange = (e) => {
		let innerValues = [];
		const selectedOption = properOptions.find(
			(option) => option.option_id.toString() === e.target.id
		);

		const existingOption = selectedValues.find(
			(item) => item.option_id === Number(e.target.id)
		);

		if (existingOption) {
			setSelectedValues((prevValues) => {
				return prevValues.filter(
					(item) => item.option_id !== Number(e.target.id)
				);
			});

			const updatedValues = selectedValues.filter(
				(item) => item.option_id !== Number(e.target.id)
			);

			innerValues = updatedValues;
		} else if (selectedOption?.option_text.toLowerCase().includes("none")) {
			setSelectedValues([selectedOption]);
			innerValues = [selectedOption];
		} else {
			if (selectedOption) {
				setSelectedValues([...selectedValues, selectedOption]);
				innerValues = [...selectedValues, selectedOption];
			}
		}

		const selectedValuesHasId = innerValues
			.map((value) => value.option_id)
			.includes(Number(target_optionId));

		if (field?.name === target_quizId) {
			if (selectedValuesHasId) {
				onLogicChange({
					action: "ADD",
					currentId: Number(target_quizId),
					targetedId: Number(target_quizid_skipped),
				});
			} else {
				onLogicChange({
					action: "REMOVE",
					currentId: Number(target_quizId),
					targetedId: Number(target_quizid_skipped),
				});
			}
		}
	};

	useEffect(() => {
		setValue(field.name, selectedValues, {
			shouldValidate: true,
			shouldTouch: true,
		});

        if (!isOtherSelected) {
			hasOthersError(false);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedValues]);

	useEffect(() => {
		const otherIndex = selectedValues.findIndex((item) =>
			item.option_text.toLowerCase().includes("other")
		);
		const copiedValues = [...selectedValues];
		copiedValues[otherIndex] = {
			...copiedValues[otherIndex],
			text_response: otherText,
		};
		if (isOtherSelected) {
			setSelectedValues(copiedValues);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [otherText]);

	const handleOthersChange = (e) => {
		const inputValue = e.target.value;

		if (inputValue.trim() === "") {
			setOtherText("");
			setError({
				show: true,
				message: "enter others here",
			});
			hasOthersError(true);
			return;
		}

		const isValid = /^[A-Za-z\s]+$/.test(inputValue);

		if (!isValid) {
			setError({
				show: true,
				message: "only letters are allowed",
			});
			hasOthersError(true);
			return;
		}

		setError({
			show: false,
			message: "",
		});
		hasOthersError(false);
		setOtherText(inputValue);
	};


	const isNoneSelected = selectedValues.find(
		(value) => value.option_text.toLowerCase().trim() === "none"
	);

	return (
		<div className={styles.inner_form_label}>
			<div className="flex mb-1 gap-2">
				<span className="text-center bg-primary text-white py-[2px] px-1 rounded-sm !text-sm mr-2 block h-6">
					{index + 1}
				</span>
				<p data-testid="checkboxes_question_">
					{question}{" "}
					<span className="text-primary-light text-sm">
						{" "}
						(Select all that applies)
					</span>
				</p>
			</div>

			<FormGroup
				style={{ display: "block", width: "100%", marginTop: "24px" }}
				data-testid="checkbox_element_container"
			>
				{properOptions.map((item, i) => {
					const isChecked = selectedValues.find(
						(value) => value.option_id === item.option_id
					);

					const isOtherSelected = isChecked?.option_text
						.toLowerCase()
						.includes("other");
					return (
						<div key={item.option_id}>
							<FormControlLabel
								key={item.option_id}
								value={item.option_id?.toString()}
								onChange={handleChange}
								control={
									<Checkbox
										id={item.option_id.toString()}
										value={item.option_id.toString()}
										checked={Boolean(isChecked)}
										disabled={
											isNoneSelected
												? isNoneSelected?.option_id !==
												  item.option_id
												: false
										}
									/>
								}
								label={item.option_text}
								className={styles.inner_radio_check}
								style={{
									outline: isChecked
										? "1px solid #BE0303"
										: "",
								}}
								data-testid="checkbox_element_field"
							/>

							{Boolean(othersOptionIndex) &&
								othersOptionIndex === i &&
								isOtherSelected && (
									<div
										className="w-full mb-3"
										data-testid="checkbox_text_input_container"
									>
										<TextField
											id="otherText"
											label="enter others here"
											variant="outlined"
											type="text"
											size="small"
											className="w-full"
											value={otherText}
											onChange={handleOthersChange}
											data-testid="checkbox_text_input"
										/>
										{error.show && (
											<small
												className="text-danger mt-2"
												data-testid="checkbox_text_input_error_element"
											>
												{error.message}
											</small>
										)}
									</div>
								)}
						</div>
					);
				})}
			</FormGroup>
			{hasError && (
				<small
					className="text-danger mt-2"
					data-testid="checkbox_error_element"
				>
					{errorMessage}
				</small>
			)}
		</div>
	);
};

export default SolinaCheckboxes;
